import { CashHistoryParams, UpdateCash } from './cash';
import { oliveApi } from '../index';

const url = `/admin/v1/cash`;

const getCashHistoryApi = async (params: CashHistoryParams) => {
  return await oliveApi.GET<CashHistoryParams, any>(`${url}`, params);
};

const updateCashHistoryApi = async (CashId: string, params: UpdateCash) => {
  return await oliveApi.PATCH<UpdateCash, any>(`${url}/${CashId}`, params);
};
export { getCashHistoryApi, updateCashHistoryApi };
